import React, { useState } from 'react';
import PropTypes from 'prop-types';

import isAre from 'common/util/isAre';

import SrFlex from 'client/components/SrFlex';
import SrFlexRow from 'client/components/SrFlexRow/SrFlexRow';
import SrText from 'client/components/SrText';
import SrLink from 'client/components/SrLink/SrLink';
import SrQualifiedListItem from 'client/components/SrQualifiedListItem/SrQualifiedListItem';
import SrBox from 'client/components/SrBox';

const SetupHealthChecks = ({ setupHealth, listingId }) => {
  const {
    checks: { orderAssigned: orderAssignedCheck, orderAccepted: orderAcceptedCheck } = {},
    jobs: { totalOrdersCount, ordersAssignedCount, ordersAcceptedCount },
  } = setupHealth;

  const [displayAssignedOrderDetail, setDisplayAssignedOrderDetail] = useState(false);

  const [displayAcceptedOrderDetail, setDisplayAcceptedOrderDetail] = useState(false);

  const _getAssignedOrderCheckComponent = () => {
    const seeMoreComponent = (
      <SrText
        font="greycliff"
        weight="600"
        color="grey"
        decoration="underline"
        paddingLeft="2px"
        cursor="pointer"
        onClick={() => setDisplayAssignedOrderDetail(!displayAssignedOrderDetail)}
      >
        see more
      </SrText>
    );

    const assignedCount = ordersAssignedCount;
    const notAssignedCount = totalOrdersCount - assignedCount;

    return (
      <SrFlexRow key={`${listingId}_orderAssignedCheck`}>
        <SrQualifiedListItem
          key={`${listingId}_orderAssigned`}
          title="Assigned Order"
          isQualified={orderAssignedCheck}
          detail={seeMoreComponent}
          marginTop="10px"
        />
        {displayAssignedOrderDetail && (
          <div>
            <SrBox marginLeft="30px">
              <SrText font="greycliff" weight="600" color="grey">
                {`${notAssignedCount} ${isAre(notAssignedCount)} not assigned.`}
              </SrText>
            </SrBox>
            <SrBox marginLeft="30px">
              <SrText font="greycliff" weight="600" color="grey">
                {`${assignedCount} ${isAre(assignedCount)} assigned.`}
              </SrText>
            </SrBox>
          </div>
        )}
      </SrFlexRow>
    );
  };

  const _getDriverAcceptedOrderCheckComponent = () => {
    const seeMoreComponent = (
      <SrText
        font="greycliff"
        weight="600"
        color="grey"
        decoration="underline"
        paddingLeft="2px"
        cursor="pointer"
        onClick={() => setDisplayAcceptedOrderDetail(!displayAcceptedOrderDetail)}
      >
        see more
      </SrText>
    );

    const acceptedCount = ordersAcceptedCount;
    const notAcceptedCount = totalOrdersCount - acceptedCount;

    return (
      <SrFlexRow key={`${listingId}_driverAcceptedOrderCheck`}>
        <SrQualifiedListItem
          key={`${listingId}_driverAcceptedOrder`}
          title="Driver Accepted Order"
          isQualified={orderAcceptedCheck}
          detail={seeMoreComponent}
          marginTop="10px"
        />
        {displayAcceptedOrderDetail && (
          <div>
            <SrBox marginLeft="30px">
              <SrText font="greycliff" weight="600" color="grey">
                {`${notAcceptedCount} ${isAre(notAcceptedCount)} not accepted.`}
              </SrText>
            </SrBox>
            <SrBox marginLeft="30px">
              <SrText font="greycliff" weight="600" color="grey">
                {`${acceptedCount} ${isAre(acceptedCount)} accepted.`}
              </SrText>
            </SrBox>
          </div>
        )}
      </SrFlexRow>
    );
  };

  return (
    <SrFlex direction="col">
      <SrFlexRow>
        <SrText font="greycliff" fontSize="18px" weight="800">
          Setup Health
        </SrText>
        <SrLink to={`/sunsetup/listing-orders/${listingId}`}>
          <SrText
            font="greycliff"
            weight="800"
            color="blue300"
            paddingLeft="5px"
            cursor="pointer"
            lineHeight="25px"
          >
            View Orders
          </SrText>
        </SrLink>
      </SrFlexRow>
      <SrFlexRow>
        {[_getAssignedOrderCheckComponent(), _getDriverAcceptedOrderCheckComponent()]}
      </SrFlexRow>
    </SrFlex>
  );
};

SetupHealthChecks.propTypes = {
  setupHealth: PropTypes.object.isRequired,
  listingId: PropTypes.number.isRequired,
};

SetupHealthChecks.displayName = 'SetupHealthChecks';

export default SetupHealthChecks;
